const NotFound = () => {

    return (
        <section id="nonFound" className="h-screen">
            <div className='flex justify-center items-center py-20'>
                <p className='text-center'>404 : 존재하지 않는 페이지입니다.</p>
            </div>
        </section>
    );
}

export default NotFound;

